import React from 'react'

export const Footer = () => {
    return (
        <div>
            <footer className="footer bottom-0  py-3">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="p-3 d-flex flex-center gap-2">
                                <img src={`${process.env.REACT_APP_API_URL}/demo1/media/auth/pwored1.png`} style={{ height: '20px' }} alt="Powered By" />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}
